export default __webpack_public_path__ + "static/media/flag.49f12614.svg";